<crowdctrl-unauthenticated-page [pageTitle]="pageTitle" [showFooter]="false" defaultHref="/login">
  <div class="about-project">
    <crowdctrl-unauth-page-intro tone="success">
      <h1 crowdctrlUnauthIntroTitle>Message sent</h1>
      <p crowdctrlUnauthIntroLead>
        We have received your message. Someone from the team may reply by email when appropriate.
      </p>
    </crowdctrl-unauth-page-intro>

    <section class="about-project__section" aria-labelledby="contact-sent-next">
      <h2 id="contact-sent-next" class="about-project__heading">What you can do next</h2>
      <p class="about-project__text">
        If you already have an account,
        <a
          href="/login"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/login')"
          >sign in here</a
        >, or return to
        <a
          href="/contact"
          class="about-project__inline-link"
          (click)="unauthNav.forward($event, '/contact')"
          >Contact</a
        >
        if you need to send another message.
      </p>
    </section>
  </div>
</crowdctrl-unauthenticated-page>
